import { Instagram, Youtube, Twitter, Music, Gamepad2, Briefcase } from "lucide-react";

const UseCases = () => {
  const platforms = [
    {
      icon: Instagram,
      name: "Instagram",
      description: "Stand out with aesthetic usernames and engaging bios that attract followers"
    },
    {
      icon: Youtube,
      name: "YouTube",
      description: "Create memorable channel names and compelling about sections"
    },
    {
      icon: Twitter,
      name: "Twitter/X",
      description: "Craft witty handles and bios that showcase your personality"
    },
    {
      icon: Music,
      name: "TikTok",
      description: "Generate catchy usernames and bios that go viral"
    },
    {
      icon: Gamepad2,
      name: "Gaming",
      description: "Find unique gamer tags for Steam, Discord, Xbox, PlayStation, and more"
    },
    {
      icon: Briefcase,
      name: "Business",
      description: "Professional usernames and bios for LinkedIn and business accounts"
    }
  ];

  return (
    <section className="w-full py-16" id="use-cases">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
          Perfect For All Platforms
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          Whether you're a content creator, influencer, gamer, or business owner, <a href="/" className="text-primary hover:underline">NameBioLab</a> helps you 
          shine on every <a href="#generator" className="text-primary hover:underline">social media platform</a>
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {platforms.map((platform, index) => {
            const Icon = platform.icon;
            return (
              <div 
                key={platform.name}
                className="p-6 rounded-lg border border-border bg-card hover:shadow-lg transition-all duration-300 hover-scale"
              >
                <Icon className="w-10 h-10 mb-4 text-primary" />
                <h3 className="text-xl font-semibold mb-2">{platform.name}</h3>
                <p className="text-muted-foreground text-sm">{platform.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
